import { Fragment } from "react";
import { HiOutlineExclamationTriangle } from "react-icons/hi2";

import Footer from "../main/Footer";
import Header from "../main/Header";
import classes from "./ErrorModal.module.css";

const ErrorModal = () => {
  const message = "Something went wrong!";

  return (
    <Fragment>
      <Header />
      <main className={classes.main}>
        <section className={classes.error}>
          <HiOutlineExclamationTriangle
            className={classes.errorIcon}
            aria-hidden
          />
          <p>{message}</p>
        </section>
      </main>
      <Footer />
    </Fragment>
  );
};

export default ErrorModal;
